module.exports = __webpack_public_path__ + "stylesheets/_slider_795fc02fb686f021c4c87e86580ad452.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/_slider.less
// module id = 7JoK
// module chunks = 153